import { composeIO } from 'react-compose-io'
import { fieldsSeparadorIO } from './FieldsSeparador.IO'
import { FieldsSeparadorView } from './FieldsSeparador.View'

export const FieldsSeparador = composeIO(FieldsSeparadorView, fieldsSeparadorIO)
